import React from 'react'
import { CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react'

interface AlertMessageProps {
 variant: 'success' | 'error' | 'warning' | 'info' | 'loading'
 message?: string
 title?: string
 errors?: Record<string, string>
 innerRef?: React.RefObject<HTMLDivElement | null>
}

const variantConfig = {
 success: {
 bg: 'bg-green-50 dark:bg-green-900/20',
 border: 'border-green-200 dark:border-green-800',
 text: 'text-green-800 dark:text-green-200',
 icon: CheckCircle,
 iconColor: 'text-green-600 dark:text-green-400'
 },
 error: {
 bg: 'bg-red-50 dark:bg-red-900/20',
 border: 'border-red-200 dark:border-red-800',
 text: 'text-red-800 dark:text-red-200',
 icon: AlertCircle,
 iconColor: 'text-red-600 dark:text-red-400'
 },
 warning: {
 bg: 'bg-orange-50 dark:bg-orange-900/20',
 border: 'border-orange-200 dark:border-orange-800',
 text: 'text-orange-800 dark:text-orange-200',
 icon: AlertTriangle,
 iconColor: 'text-orange-600 dark:text-orange-400'
 },
 info: {
 bg: 'bg-blue-50 dark:bg-blue-900/20',
 border: 'border-blue-200 dark:border-blue-800',
 text: 'text-blue-800 dark:text-blue-200',
 icon: Info,
 iconColor: 'text-blue-600 dark:text-blue-400'
 },
 loading: {
 bg: 'bg-blue-50 dark:bg-blue-900/20',
 border: 'border-blue-200 dark:border-blue-800',
 text: 'text-blue-800 dark:text-blue-200',
 icon: null,
 iconColor: 'text-blue-600'
 }
}

export const AlertMessage: React.FC<AlertMessageProps> = ({
 variant,
 message,
 title,
 errors,
 innerRef
}) => {
 const config = variantConfig[variant]
 const Icon = config.icon

 return (
 <div 
 ref={innerRef}
 className={`${config.bg} border ${config.border} rounded-lg p-4`}
 >
 <div className="flex items-start">
 {variant === 'loading' ? (
 <div className={`animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600 mr-2 flex-shrink-0`}></div>
 ) : Icon ? (
 <Icon className={`h-5 w-5 ${config.iconColor} mr-${errors ? '3' : '2'} ${errors ? 'mt-0.5' : ''} flex-shrink-0`} />
 ) : null}
 
 {errors ? (
 <div className="flex-1">
 {title && (
 <p className={`font-medium ${config.text} mb-2`}>
 {title}
 </p>
 )}
 <ul className={`list-disc list-inside space-y-1 text-sm ${config.text.replace('800', '700').replace('200', '300')}`}>
 {Object.entries(errors).map(([field, msg]) => (
 <li key={field}>{msg}</li>
 ))}
 </ul>
 </div>
 ) : (
 <p className={config.text}>{message}</p>
 )}
 </div>
 </div>
 )
}

